export default __webpack_public_path__ + "static/media/FEDE-OING.410a7b7f.png";